import { BREAKPOINTS_NUM } from "@/constants/breakPoints";
import { create } from "zustand";

export const resiseEvent = () => {
  if (window.innerWidth < BREAKPOINTS_NUM["2xl"]) {
    return "compact";
  }
  return "full";
};

interface SidebarState {
  showSecondSidebar: boolean;
  isShowingSidebar: "full" | "compact";
  setIsShowingSidebar: (value: "full" | "compact") => void;
  toggleSecondSidebar: () => void;
  setSecondSidebar: (value: boolean) => void;
}

export const useSidebarStore = create<SidebarState>((set) => ({
  showSecondSidebar: true,
  isShowingSidebar: resiseEvent(),
  setIsShowingSidebar: (value) => set(() => ({ isShowingSidebar: value })),
  toggleSecondSidebar: () =>
    set((state) => ({ showSecondSidebar: !state.showSecondSidebar })),
  setSecondSidebar: (value: boolean) => set({ showSecondSidebar: value }),
}));
